/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";

class ETSection1 extends Component {
    // constructor() {
    //     super();
    //
    // }
    // componentDidMount(){
    //     });
    // }

    render() {

        return (
            <div>
                <div className="section-5-et block-4 z-13">
                    <div className="container relative-text">
                        <div className="row mb0">
                            <div className="col s12 m12 l7 left-align mobile-center">
                                <br/>
                                <img className="responsive-img relative-text" src="../static/Mastermind-Take-Ownership-Text.png"/>
                                <br className="hide-on-large-only"/>
                            </div>
                            <div className="col s12 m10 offset-m1 l5 center-align">
                                <br/>
                                <img className="img-neg-m img-sticky img-reverse" src="../static/Mastermind-ET-2.png" alt="Eric Thomas" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )

    }

}

export default ETSection1;


// WEBPACK FOOTER //
// ./src/components/et-section1.js